module.exports = __webpack_public_path__ + "img/recognition-header-bubble-2.4e660da6.png";